import http from '../utils/http-common';
import {
  AnalyticsInput,
  MultiUserAnalyticsResponse,
  UserChatDataResponse,
} from '../types/user.types';
import {
  AgentAnalyticsInput,
  AgentChatListInput,
  AgentChatListResponse,
  AgentEngagementResponse,
  AgentStatsOverviewResponse,
  AssistantAnalyticsInput,
  AssistantChatListInput,
  AssistantChatListResponse,
  AssistantEngagementResponse,
  AssistantQueryAnalysisResponse,
  AssistantStatsOverviewResponse,
  AssistantStudentsDataResponse,
  LearningProgressResponse,
  TutorAnalyticsInput,
  TutorEngagementResponse,
  TutorLearningProgressResponse,
  TutorQueryAnalysisResponse,
  TutorStatsOverviewResponse,
  TutorStudentsDataResponse,
  TutorChatDataResponse,
  GetTutorChatDataInput,
  GetUserTutorChatWithInsightsInput,
  UserTutorChatWithInsightsResponse,
  UserEngagementResponse,
  QuizAnalyticsInput,
  QuizDataTableInput,
  QuizStatsOverviewResponse,
  QuizOverviewAnalyticsResponse,
  QuizLearningProgressResponse,
  QuizDataTableResponse,
  GetUserQuizDataInput,
  UserQuizDataResponse,
} from '../types/analytics.types';

const getSingleUserAnalytics = (data: AnalyticsInput) => {
  return http.post<UserChatDataResponse>('/analytics/single-user', data);
};

const getMultipleUserAnalytics = (data: AnalyticsInput) => {
  return http.post<MultiUserAnalyticsResponse>(
    '/analytics/multiple-user',
    data
  );
};

const fetchEngagementStats = (data: AnalyticsInput) => {
  return http.post<UserEngagementResponse>('/analytics/user-engagement', data);
};

const fetchLearningProgressStats = (data: AnalyticsInput) => {
  return http.post<LearningProgressResponse>(
    '/analytics/learning-progress',
    data
  );
};

const fetchAssistantAnalytics = (data: AssistantAnalyticsInput) => {
  return http.post<AssistantStatsOverviewResponse>(
    '/analytics/assistant/overview',
    data
  );
};

const fetchAssistantQueryAnalysis = (data: AssistantAnalyticsInput) => {
  return http.post<AssistantQueryAnalysisResponse>(
    '/analytics/assistant/query-analysis',
    data
  );
};

const fetchAssistantChatData = (data: AssistantChatListInput) => {
  return http.post<AssistantChatListResponse>(
    '/analytics/assistant/chat-data',
    data
  );
};

const fetchAssistantProgressStats = (data: AssistantAnalyticsInput) => {
  return http.post<LearningProgressResponse>(
    '/analytics/assistant/learning-progress',
    data
  );
};

const fetchStudentStats = (data: AssistantAnalyticsInput) => {
  return http.post<AssistantStudentsDataResponse>(
    '/analytics/assistant/student-stats',
    data
  );
};

const fetchAssistantEngagementStats = (data: AssistantAnalyticsInput) => {
  return http.post<AssistantEngagementResponse>('/analytics/assistant/engagement', data);
};

//Agent
const fetchAgentChatData = (data: AgentChatListInput) => {
  return http.post<AgentChatListResponse>(
    '/analytics/agent/chat-data',
    data
  );
};

const fetchAgentEngagementStats = (data: AgentAnalyticsInput) => {
  return http.post<AgentEngagementResponse>('/analytics/agent/engagement', data);
};

const fetchAgentProgressStats = (data: AgentAnalyticsInput) => {
  return http.post<LearningProgressResponse>(
    '/analytics/agent/learning-progress',
    data
  );
};

const fetchAgentQueryAnalysis = (data: AgentAnalyticsInput) => {
  return http.post<AssistantQueryAnalysisResponse>(
    '/analytics/agent/query-analysis',
    data
  );
};

const fetchAgentAnalytics = (data: AgentAnalyticsInput) => {
  return http.post<AgentStatsOverviewResponse>(
    '/analytics/agent/overview',
    data
  );
};

const fetchAgentStudentStats = (data: AgentAnalyticsInput) => {
  return http.post<AssistantStudentsDataResponse>(
    '/analytics/agent/student-stats',
    data
  );
};

const fetchTutorAnalytics = (data: TutorAnalyticsInput) => {
  return http.post<TutorStatsOverviewResponse>(
    '/analytics/tutor/overview',
    data
  );
};

const fetchTutorQueryAnalysis = (data: TutorAnalyticsInput) => {
  return http.post<TutorQueryAnalysisResponse>(
    '/analytics/tutor/query-analysis',
    data
  );
};

const fetchTutorEngagementStats = (data: TutorAnalyticsInput) => {
  return http.post<TutorEngagementResponse>(
    '/analytics/tutor/engagement',
    data
  );
};

const fetchTutorProgressStats = (data: TutorAnalyticsInput) => {
  return http.post<TutorLearningProgressResponse>(
    '/analytics/tutor/learning-progress',
    data
  );
};

const fetchTutorStudentStats = (data: TutorAnalyticsInput) => {
  return http.post<TutorStudentsDataResponse>(
    '/analytics/tutor/student-stats',
    data
  );
};

const fetchTutorChatData = (data: GetTutorChatDataInput) => {
  return http.post<TutorChatDataResponse>(
    '/analytics/tutor/chat-data',
    data
  );
};

const fetchUserTutorChatWithInsights = (data: GetUserTutorChatWithInsightsInput) => {
  return http.post<UserTutorChatWithInsightsResponse>(
    '/analytics/tutor/user-chat-insights',
    data
  );
};

// Quiz Analytics
const fetchQuizStatsOverview = (data: QuizAnalyticsInput) => {
  return http.post<QuizStatsOverviewResponse>(
    '/analytics/quiz/overview',
    data
  );
};

const fetchQuizOverviewAnalytics = (data: QuizAnalyticsInput) => {
  return http.post<QuizOverviewAnalyticsResponse>(
    '/analytics/quiz/query-analysis',
    data
  );
};

const fetchQuizLearningProgress = (data: QuizAnalyticsInput) => {
  return http.post<QuizLearningProgressResponse>(
    '/analytics/quiz/learning-progress',
    data
  );
};

const fetchQuizDataTable = (data: QuizDataTableInput) => {
  return http.post<QuizDataTableResponse>(
    '/analytics/quiz/data-table',
    data
  );
};

const fetchUserQuizData = (data: GetUserQuizDataInput) => {
  return http.post<UserQuizDataResponse>(
    '/analytics/quiz/user-data',
    data
  );
};


const AnalyticsService = {
  fetchEngagementStats,
  getSingleUserAnalytics,
  getMultipleUserAnalytics,
  fetchLearningProgressStats,
  fetchStudentStats,

  fetchAssistantAnalytics,
  fetchAssistantQueryAnalysis,
  fetchAssistantChatData,
  fetchAssistantProgressStats,
  fetchAssistantEngagementStats,

  fetchAgentChatData,
  fetchAgentEngagementStats,
  fetchAgentProgressStats,
  fetchAgentQueryAnalysis,
  fetchAgentAnalytics,
  fetchAgentStudentStats,

  fetchTutorAnalytics,
  fetchTutorQueryAnalysis,
  fetchTutorEngagementStats,
  fetchTutorProgressStats,
  fetchTutorStudentStats,
  fetchTutorChatData,
  fetchUserTutorChatWithInsights,

  fetchQuizStatsOverview,
  fetchQuizOverviewAnalytics,
  fetchQuizLearningProgress,
  fetchQuizDataTable,
  fetchUserQuizData,
};

export default AnalyticsService;
